export default "__VITE_ASSET__39493a83__"